import { cardSubmissionsContract } from "@openrift/shared/contracts/card-submissions";
import type { CardSubmissionListResponse } from "@openrift/shared/contracts/card-submissions";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { cardSubmissionsKeys } from "@/features/contribute/lib/contribute-query-keys";
import { withCookies } from "@/lib/server-fns/middleware";
import { apiOrpcClient } from "@/lib/server-fns/orpc-client";

const fetchCardSubmissionsFn = createServerFn({ method: "GET" })
  .validator((input: { cursor?: string }) => input)
  .middleware([withCookies])
  .handler(({ context, data }): Promise<CardSubmissionListResponse> =>
    apiOrpcClient(cardSubmissionsContract, context.cookie).list(
      data.cursor ? { cursor: data.cursor } : {},
    ),
  );

/** The API scopes to the session user; `userId` here only keys the cache. */
export function cardSubmissionsQueryOptions(userId: string) {
  return infiniteQueryOptions({
    queryKey: cardSubmissionsKeys.all(userId),
    queryFn: ({ pageParam }): Promise<CardSubmissionListResponse> =>
      fetchCardSubmissionsFn({
        data: { cursor: pageParam },
      }) as Promise<CardSubmissionListResponse>,
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage: CardSubmissionListResponse) => lastPage.nextCursor ?? undefined,
  });
}
